import { RecoilState, atom } from "recoil";

export const zoomState: RecoilState<number> = atom({
  key: "zoomState",
  default: 1,
});